var _style, _path, _path2, _text, _text2, _path3, _path4, _path5, _g, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none}.st1{fill:#fff}.st2{font-family:Raleway; font-weight: 100;}.st6{fill:none;stroke:#000;stroke-width:3;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.07-1l-9.62 17.24-8.36 14.96L369.93 139H-1V-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1 139h479.92v.01H-1z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(261.994 65.233)",
    className: "st1 st2",
    fontSize: 57
  }, "Arc")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(17.692 112.015)",
    className: "st1 st2",
    fontSize: 54
  }, "Development")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.44 116.43l47.65-85.23 8.36-14.96M369.83 139l-.01.01L362 153"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M438.76 15.76l-56.42 100.91c-12.52-10.83-20.45-26.82-20.45-44.67 0-32.58 26.42-59 59-59 6.23 0 12.24.97 17.87 2.76z",
    fill: "#0b72b9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M479.89 72c0 32.58-26.42 59-59 59-14.73 0-28.21-5.4-38.55-14.33l56.42-100.91c23.85 7.57 41.13 29.89 41.13 56.24z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    transform: "translate(30.153 11.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Words"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    className: "st1",
    d: "M405.05 14.4l-.09 80.38-7.67-.01.06-52.25-29.4 52.21-7.94-.01 45.04-80.32z"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457-17l-8.93 16-9.62 17.24-8.36 14.96L369.93 139l-.01.01L361 155"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b9bbc23c635093fd1e4b08124fcee86c.svg";
export { ForwardRef as ReactComponent };